import * as type from '../../ActionTypes';

const initialState = {
  contact: {},
  loading: false,
  error: '',
  contactStatus: false,
  massage: ''
};

export default function contactSupport(state = initialState, action: any) {
  switch (action.type) {
    case type.POST_CONTACT_SUPPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        contact: {},
        contactStatus: false,
        massage: ''
      };
    case type.POST_DISPUTE_REQUEST:
      return {
        ...state,
        loading: true,
        error: '',
        contact: {},
        contactStatus: false,
        massage: ''
      };
    case type.POST_CONTACT_SUPPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        contact: action.contact,
        contactStatus: true,
        massage: 'Thank you. Our team will contact you within 4 business days'
      };
    case type.POST_CONTACT_SUPPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.message,
        contactStatus: false,
        massage: ''
      };
    case type.RESET_CONTACT_SUPPORT:
      return {
        ...initialState
      };
    default:
      return state;
  }
}
